






















import Vue from 'vue'
import SectionTitle from '@/product/components/SectionTitle.vue'
import SelectAdditionalOption from '@/product/components/additionalOptions/SelectAdditionalOption.vue'
import { ProductState } from '@/product/types'
import { AdditionalOption } from '@/common/types'

export default Vue.extend({
  components: {
    SectionTitle,
    SelectAdditionalOption
  },
  computed: {
    storeState(): ProductState {
      return this.$store.state
    },
    additionalOptions(): AdditionalOption[] {
      return this.storeState.additionalOptions
    }
  },
  methods: {
    setSelectedAdditionalOptionIds(ids: string[]) {
      this.$store.commit('setSelectedAdditionalOptionIds', ids)
      this.$emit('update')
    }
  }
})
